const useRandom = ({ fieldType, field_type_id }: { fieldType: string; field_type_id: number }) => {
  const id = Math.floor(Math.random() * 1000);
  const user_id = Math.floor(Math.random() * 1000);
  const sort = Math.floor(Math.random() * 100);

  const newFormField = {
    id,
    label: fieldType.charAt(0).toUpperCase() + fieldType.substring(1).toLowerCase(),
    is_required: true,
    placeholder: ['select', 'multi_select', 'checkbox', 'radio'].includes(fieldType) ? "Select value" : `Enter ${fieldType} value`,
    error_message: `${fieldType} value is required!`,
    is_visible: true,
    hide_label: false,
    value: "",
    options: [
      {
        label: "Option1",
        value: "Option1",
        is_selected: true,
      },
      {
        label: "Option2",
        value: "Option2",
        is_selected: false,
      },
      {
        label: "Option3",
        value: "Option3",
        is_selected: true,
      },
    ],
    sort,
    applicable_to_form: "appointment/patient_info",
    user_id,
    field_type_id,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  };

  return { newFormField };
};

export default useRandom;
